export default function getTABRoutes(tier) {
    return {
        GENERAL_INFO: 'tab.task.generalInfo',
        APP_NAMING: 'tab.task.appNaming',
        ...(tier === 'tier3'
            ? {
                AFFILIATIONS: 'tab.task.affiliations',
                FEATURES: 'tab.task.features',
                APP_COLORS: 'tab.task.appColors'
            }
            : {}),
        APP_ICONOGRAPHY: 'tab.task.appIcons',
        VENUES: 'tab.task.venues',
        TEAMS: 'tab.task.teams'
    }
}
